/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdAddressesAddresspersonidMutationRequest,
  PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
  PutApiV1PersonIdAddressesAddresspersonidPathParams,
  PutApiV1PersonIdAddressesAddresspersonid400,
  PutApiV1PersonIdAddressesAddresspersonid401,
  PutApiV1PersonIdAddressesAddresspersonid404,
  PutApiV1PersonIdAddressesAddresspersonid500,
} from "../../types/personRegisterController/PutApiV1PersonIdAddressesAddresspersonid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdAddressesAddresspersonid } from "../../clients/personRegisterController/putApiV1PersonIdAddressesAddresspersonid.ts";

export const putApiV1PersonIdAddressesAddresspersonidMutationKey = () =>
  [{ url: "/api/v1/person/:id/addresses/:addressPersonId" }] as const;

export type PutApiV1PersonIdAddressesAddresspersonidMutationKey = ReturnType<
  typeof putApiV1PersonIdAddressesAddresspersonidMutationKey
>;

export function putApiV1PersonIdAddressesAddresspersonidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1PersonIdAddressesAddresspersonidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1PersonIdAddressesAddresspersonidMutationKey();
  return mutationOptions<
    PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAddressesAddresspersonid400
      | PutApiV1PersonIdAddressesAddresspersonid401
      | PutApiV1PersonIdAddressesAddresspersonid404
      | PutApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, addressPersonId, data }) => {
      return putApiV1PersonIdAddressesAddresspersonid(
        id,
        addressPersonId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Atualiza os dados de um endereço vinculado à pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/:addressPersonId}
 */
export function usePutApiV1PersonIdAddressesAddresspersonid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdAddressesAddresspersonid400
        | PutApiV1PersonIdAddressesAddresspersonid401
        | PutApiV1PersonIdAddressesAddresspersonid404
        | PutApiV1PersonIdAddressesAddresspersonid500
      >,
      {
        id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"];
        addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
        data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdAddressesAddresspersonidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1PersonIdAddressesAddresspersonidMutationKey();

  const baseOptions = putApiV1PersonIdAddressesAddresspersonidMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAddressesAddresspersonid400
      | PutApiV1PersonIdAddressesAddresspersonid401
      | PutApiV1PersonIdAddressesAddresspersonid404
      | PutApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAddressesAddresspersonid400
      | PutApiV1PersonIdAddressesAddresspersonid401
      | PutApiV1PersonIdAddressesAddresspersonid404
      | PutApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAddressesAddresspersonid400
      | PutApiV1PersonIdAddressesAddresspersonid401
      | PutApiV1PersonIdAddressesAddresspersonid404
      | PutApiV1PersonIdAddressesAddresspersonid500
    >,
    {
      id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"];
      addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"];
      data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest;
    },
    TContext
  >;
}
